import { KEY } from 'store/booking/types';

export const GET_VISIT_TYPES = `${KEY}.GET_VISIT_TYPES`;
export const GET_VISIT_TYPES_SUCCESS = `${KEY}.GET_VISIT_TYPES_SUCCESS`;
export const GET_VISIT_TYPES_FAIL = `${KEY}.GET_VISIT_TYPES_FAIL`;

export const getVisitTypes = (
  consumerId: string,
  providerId: string | number,
  birthdate: string
) => ({
  type: GET_VISIT_TYPES,
  payload: {
    client: 'booking',
    request: {
      url: `/booking/visittypes/${providerId}`,
      headers: {
        consumerId,
        birthdate
      }
    }
  }
});
